import React from 'react';
import { OverlayLoading } from '../../module/global/component/OverlayLoading';

type Input = { children: React.ReactNode };

export function SuspenseLoader(input: Input) {
    return <React.Suspense fallback={<OverlayLoading />}>{input.children}</React.Suspense>;
}
